import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import Loader from "./layout/Loader";
import Aux from "../hoc/_Aux";
import ScrollToTop from "./layout/ScrollToTop";
import routes from "../route";
import { ToastContainer } from "../Pages/Containers";
//import "./../assets/scss/style.scss";
import "./../assets/scss/theme.scss";

import AdminLayout from "./components/HorizontalLayout";

const App = () => {
  const menu = routes.map((route, index) => {
    return route.component ? (
      <Route key={index} path={route.path} element={route.component} />
    ) : null;
  });

  return (
    <div>
      <Aux>
        <ToastContainer />
        <ScrollToTop>
          <Suspense fallback={<Loader />}>
            <Routes>
              {menu}
              <Route path="*" element={<AdminLayout />} />
            </Routes>
          </Suspense>
        </ScrollToTop>
      </Aux>
    </div>
  );
};

export default App;
